import { AppContext } from "@Context/common/general/context";
import { hasVerifiedClientVersion } from "@Helpers/analytics-utils";
import * as Sentry from "@sentry/react";
import amplitude from "amplitude-js";
import { useContext, useEffect } from "react";

interface IClientVersionAnalyticsService {
  allowUnverifiedClientVersions?: boolean;
}

/**
 * 
 * @param allowUnverifiedClientVersions - If true, will allow unverified client versions to be sent to analytics. We use this to distinguish Web Portal events from VR and Mobile App events, which both have their own explicit client versions.
 * @returns 
 */
const ClientVersionAnalyticsService = ({ allowUnverifiedClientVersions = false }: IClientVersionAnalyticsService) => {
  const { state } = useContext(AppContext);
  const clientVersion = state.app.clientVersion;

  useEffect(() => {
    if (!hasVerifiedClientVersion(clientVersion) && !allowUnverifiedClientVersions) {
      return;
    }

    Sentry.setTag("client_version", clientVersion);

    amplitude.getInstance().setVersionName(clientVersion);
  }, [clientVersion]);

  return null;
};

export default ClientVersionAnalyticsService;
